import React from 'react';
import { deckPages } from '../../data/deck';
interface PageNavProps {
  active: string;
}

/** Quiet dot rail: the IVF Pulse story, then optional Snakker capabilities. */
export function PageNav({
  active
}: PageNavProps) {
  const activeIndex = Math.max(0, deckPages.findIndex(page => page.id === active));
  const mainCount = deckPages.filter(page => page.group === 'main').length;
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <nav aria-label="Presentation pages" className="fixed right-5 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-end gap-3 lg:flex" data-id="element-290" data-mp="80md4vk9pv1z">
      {deckPages.map((page, i) => {
      const isActive = i === activeIndex;
      const isMore = page.group === 'more';
      return <React.Fragment key={page.id} data-id="element-291" data-mp="3q7ah2i3l0c62" data-mpi={i}>
            {i === mainCount && <span className="mt-1 text-[8.5px] font-bold uppercase tracking-[0.18em] text-[var(--fg)]/35" aria-hidden="true" data-id="element-292" data-mp="3l9qqcipp66x8">
                More
              </span>}
            <button type="button" onClick={() => goTo(page.id)} aria-label={`Page ${i + 1}: ${page.label}`} aria-current={isActive ? 'true' : undefined} className="group flex items-center gap-3 focus:outline-none" data-id="element-293" data-mp="3m3ky2tkkupf6">
              <span className="pointer-events-none whitespace-nowrap rounded-full bg-white px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-[var(--fg)] opacity-0 shadow-sm ring-1 ring-[var(--fg)]/10 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-294" data-mp="3xgd8r2nh2qp">
                {String(i + 1).padStart(2, '0')} · {page.label}
              </span>
              <span className={['block rounded-full transition-all duration-300 group-focus-visible:ring-2 group-focus-visible:ring-[var(--brand)] group-focus-visible:ring-offset-2', isActive ? 'h-6 w-1.5 bg-[var(--brand)]' : isMore ? 'h-1 w-1 bg-[var(--fg)]/15 group-hover:bg-[var(--fg)]/50' : 'h-1.5 w-1.5 bg-[var(--fg)]/25 group-hover:bg-[var(--fg)]/50'].join(' ')} data-id="element-295" data-mp="2eq12sve7ocyd" />
            </button>
          </React.Fragment>;
    })}
      <span className="mt-2 text-[10px] font-semibold tabular-nums tracking-[0.12em] text-[var(--fg)]/40" data-id="element-296" data-mp="6hw9wu3p1egn">
        {String(activeIndex + 1).padStart(2, '0')}/{String(deckPages.length).padStart(2, '0')}
      </span>
    </nav>;
}